import { ThemeComponents } from "@chakra-ui/react";
import Container from "./Container";
import Button from "./Button";
import Heading from "./Heading";
import Badge from "./Badge";
import Alert from "./Alert";
import Modal from "./Modal";

const components: ThemeComponents = { Container, Button, Heading, Badge, Alert, Modal };

export default components;
